import React, { Component } from 'react';
import { Row, Col, FormGroup, FormControl, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/Credit';

export default class Credit extends Component {
  options = () => ({
    field1: this.props.field1,
    field2: this.props.field2,
  });

  handleContent(index) {
    const options = this.options();

    options.field1 = index;
    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  handleOtherContent(e) {
    const options = this.options();

    options.field2 = e.target.value;
    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <div className="questions">
              <p className="question">
                Will a credit be provided to the contributor for their
                contribution?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="credit"
                  checked={this.props.field1 === 0}
                  readOnly
                  onClick={(e) => this.handleContent(0)}
                >
                  A credit is not required, but may be provided at the content
                  owner’s discretion.
                </Radio>
                <Radio
                  name="credit"
                  checked={this.props.field1 === 1}
                  readOnly
                  onClick={(e) => this.handleContent(1)}
                >
                  A credit will be given to this Contributor only if others in
                  similar roles are given credit too. Each person playing a
                  similar role will receive the same credit. (For example, if
                  two collaborators contribute as writers, each will be given
                  credit as a “Writer” or “Co-writer” of the work in the same
                  size, placement, and prominence.)
                </Radio>
                <Radio
                  name="credit"
                  checked={this.props.field1 === 2}
                  readOnly
                  onClick={(e) => this.handleContent(2)}
                >
                  A credit will be provided to this Contributor for their
                  contribution.
                </Radio>

                {this.props.field1 === 2 ? (
                  <FormGroup className="answer">
                    <FormControl
                      type="text"
                      placeholder="enter the credit to be provided here (e.g. Produced by Johnny Jay)"
                      value={this.props.field2}
                      onChange={(e) => this.handleOtherContent(e)}
                    />
                  </FormGroup>
                ) : null}
              </FormGroup>
            </div>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  A credit acknowledges a Contributor for their contribution to
                  the work(s) (e.g. written by, produced by, directed by, etc.).
                  Providing credit to a contributor can include publicly listing
                  their name, likeness, logos, trademarks, biographical
                  information, and their role in the creation of the work(s).
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/Credit.jsx